<template>
  <q-card
    flat
    class="solutionCard"
    :style="`width: 275px; height: ${largeVersion ? '342px' : '230px'}`"
  >
    <q-card-section v-if="data" class="q-pa-none">
      <q-img
        :style="`width: 275px; height: 180px`"
        :src="
          data.imageUrl
            ? data.imageUrl
            : 'https://via.placeholder.com/275x180.png'
        "
      >
        <div class="full-width bg-transparent" style="padding: 10px !important">
          <div class="row justify-between">
            <div>
              <!-- <q-icon
                                    v-if="solution.solutionsBusiness_id"
                                    name="mdi-check-circle"
                                    color="primary"
                                    size="sm"
                                  >
                                  </q-icon> -->
            </div>
            <div class="row">
              <q-img
                v-if="
                  outcome.outcomes_id &&
                  outcomeKeyReferenceList[outcome.outcomes_id]
                "
                v-for="(outcome, index) in data.outcomes"
                :key="`outcome_${index}`"
                class="q-mx-auto q-mr-md"
                style="width: 24px; height: 24px; margin-left: 5px"
                :src="
                  getOutcomeImage({
                    name: outcomeKeyReferenceList[outcome.outcomes_id].name,
                  })
                "
              >
                <q-tooltip>
                  {{ outcomeKeyReferenceList[outcome.outcomes_id].label }}
                </q-tooltip>
              </q-img>
            </div>
          </div>
        </div>
      </q-img>
    </q-card-section>
    <q-card-section v-if="data">
      <div class="row">
        <div class="col-12">
          <h4 class="q-my-none">
            {{ data.title }}
          </h4>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import { getCSSVars } from "@/functions/cssVars";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";

  export default {
    props: {
      data: {
        default: null,
      },
      largeVersion: {
        default: true,
        type: Boolean,
      },
    },
    components: {},
    computed: {
      ...mapGetters({
        outcomeKeyReferenceList: "outcomes/keyReferenceList",
      }),
      cssVars() {
        let outcome = this.selectedOutcome;
        return getCSSVars(outcome);
      },
    },

    data: () => ({}),
    watch: {},
    async mounted() {},
    methods: {
      getOutcomeImage: getOutcomeImage,
      getCSSVars: getCSSVars,
    },
  };
</script>

<style lang="scss" scoped>
  .solutionCard {
    h4 {
      font-size: 1rem;
      font-weight: 600;
      color: $accent;
      line-height: 1.1rem;
    }
  }
</style>
